export const DOW_JONES_BLOCKED = 'BLOCKED';
export const DOW_JONES_CLEAR = 'CLEAR';
export const DOW_JONES_REVIEWED_BLOCKED = 'REVIEWED_BLOCKED';
export const DOW_JONES_REVIEWED_CLEAR = 'REVIEWED_CLEAR';
